import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FlagIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16,6c-2,0-3-2-5-2H6A1,1,0,0,0,5,5V20a1,1,0,0,0,2,0V14h4c2,0,3,2,5,2h3a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1Z"
  })]
}), 'FlagIcon');